import { EventCodes } from '../../../../App/model/event-codes';

(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxSidePanelTabHeader', {
		bindings: {
			view: '<',
		},
		controller: MxSidePanelTabHeaderCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-side-panel/mx-side-panel-tab-header.html',
	});

	MxSidePanelTabHeaderCtrl.$inject = [
		'$scope',
		'mx.shell.SideLayout',
		'mx.shell.SidePanelService',
		'mx.shell.SidePanelActionsService',
		'mx.SolutionBuilderAgent.FavouritesService',
		'mx.SolutionBuilderAgent.ViewHelpService',
		'mx.shell.EventService',
	];

	function MxSidePanelTabHeaderCtrl($scope, sideLayoutService, sidePanelService, sidePanelActionsService, favouritesService, viewHelpService, eventService) {
		var vm = this;
		var currentView;

		vm.currentUIActions = [];

		vm.sideLayoutService = sideLayoutService;
		vm.sidePanelService = sidePanelService;
		vm.sidePanelActionsService = sidePanelActionsService;
		vm.favouritesService = favouritesService;
		vm.viewHelpService = viewHelpService;

		Object.defineProperty(vm, 'view', {
			get: function () {
				return currentView;
			},
			set: function (newView) {
				currentView = newView;
			},
		});

		$scope.$watch(
			'vm.view.uiActionGroup',
			function (uiActionGroup) {
				if (uiActionGroup) {
					reloadUIActions(currentView ? currentView && currentView.uiActionGroup : 'selection', currentView);
				}
			},
			true
		);

		vm.onCloseClick = onCloseClick;

		return vm;

		function reloadUIActions(uiActionGroup, view) {
			vm.currentUIActions = vm.sidePanelActionsService.getUIActions(uiActionGroup, view);
		}

		function onCloseClick() {
			eventService.dispatchEvent(EventCodes.TrackViewTelemetry, { eventName: '{viewName} closed', view: vm.view });
			vm.sidePanelService.closeCurrentView();
		}
	}
})();
